<header class="l-header">
  <!-- ── Mobile nav toggle (hidden on desktop) ──────────── -->
  <button
    class="l-header__hamburger"
    (click)="sidebarService.toggleMobile()"
    aria-label="Open navigation menu"
  >
    <mat-icon>{{ sidebarService.mobileOpen() ? 'close' : 'menu' }}</mat-icon>
  </button>
  <ng-content></ng-content>
</header>
